export const apiSplunk = async (userName, mail, error, errorBool, tipoVoz) => {
    // Logic App: setLogSplunk_App
    const postData = {
        userName: userName,
        mail: mail,
        error: 'N/A',
        currentDate: new Date(),
        type: tipoVoz,
        officeLocation: '',
        department: ''
    }

    if (errorBool) {
        postData.error = error;
    }

    const raw = JSON.stringify(
        {
            apiKey:"&REACT_APP_APIKEY_SPLUNK&",
            data: postData,
            indice:"&REACT_APP_INDEX_SPLUNk&"
        }
    );

    await fetch("&REACT_APP_ENV_SPLUNK&", {
        method: 'POST',
        headers: { "Content-Type": "application/json" },
        body: raw
    })
};

export const sendEmail = async (nombreAsunto, targetName, targetEmail, descripcionVoz, competencias, footerText, subjectDescription,url,descripcion,btn,gift) => {
    // Logic App: sendEmailVozAvos_App/sendEmailVozAvosPRD_App
    const dataForEmail = JSON.stringify(
        {
            "competencias": competencias,
            "descripcionVoz": descripcionVoz,
            "footerText": footerText,
            "name": targetName,
            "subject": nombreAsunto,
            "subjectDescription": subjectDescription,
            "to": targetEmail, //"ejemplo@proteccion.com.co" Para ensayar dar y pedir voces a uno mismo //targetEmail //"sarboler@proteccion.com.co"
            "url": url,
            "feedback": descripcion,
            "btn": btn,
            "gift": gift,
        }
    );
    
    await fetch("&REACT_APP_URL_SENDEMAIL&", {
        method: 'POST',
        headers: { "Content-Type": "application/json" },
        body: dataForEmail
    })
};